import React from 'react';
import ApplicationPanel from './ApplicationPanel';
import EvaluationPanel from './EvaluationPanel';
import { EvaluatorApplicationDetails, Evaluation } from '../../types/evaluator';
import styles from './EvaluationStep.module.css';

interface EvaluationStepProps {
  application: EvaluatorApplicationDetails;
  evaluation: Evaluation | null;
}

const EvaluationStep: React.FC<EvaluationStepProps> = ({
  application,
  evaluation,
}) => {
  return (
    <div className={styles.container}>
      <div className={styles.layout}>
        <div className={styles.applicationPanel}>
          <ApplicationPanel application={application} />
        </div>
        <div className={styles.evaluationPanel}>
          <EvaluationPanel application={application} evaluation={evaluation} />
        </div>
      </div>
    </div>
  );
};

export default EvaluationStep;